import styled from 'styled-components';
import { device } from "../../device";


export const StyledMenu = styled.nav`
        padding: 64px 0 48px;
        position: fixed;
        left: 0;
        top: 0;
        height: 100vh;
        padding-top: 56px;
        background: #fff;
        overflow-y: auto;
        overscroll-behavior: contain;
        width: 100%;
        z-index: 100;
        -webkit-overflow-scrolling: touch;
        transform: ${({ openNav }) => openNav ? 'translate(0,0)' : 'translate(100%,0)'};
        will-change: transform;
        transition: transform 0.3s ease-in-out;
        width: 100%;
        @media ${device.lg} {
            display: none;
        }
    `;
export const MenuList = styled.ul`
    list-style: none;
    margin: 0;
    padding: 0;
`;
export const Item = styled.li`
    &:not(:last-child) {
        margin-bottom: 16px;
    }
`;
export const MenuBtn = styled.button`
    position: relative;

    display: block;
    padding: 6px 24px;
    margin-bottom: 8px;
    width: 100%;

    font-size: 18px;
    font-weight: 500;

    background: transparent;
    border: none;
    cursor: pointer;

    text-align: left;
    outline: 0;
    transition: background .2s ease-in-out;
    &.active-item {
        background: var(--light-gray1);
    }
`;
export const MobMenuHeader = styled.div`
    padding: 16px 16px 20px;
`;
export const MobMenuHeaderRow = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
`;
export const HelpBlock = styled.div`
    color: var(--brand);
    font-size: 12px;
    line-height: 16px;
    margin-top: 20px;
    transition: color .15s ease-in-out;
    will-change: color;
    a {
        color: var(--brand);
        text-decoration: underline;
        transition: color .15s ease-in-out;
        will-change: color;
    }
`;